export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSmMarketKod';
export const NAME = 'MarketovaSkupina';
